import type { EndpointDef } from '@skynet/data-helpers';

/**
 * Central endpoint definitions — single source of truth for the Telegram
 * Groups API.
 */
export const TELEGRAM_GROUPS_API_ENDPOINTS = {
  createTelegramGroup: {
    generated: 'telegramGroupsAdminControllerCreateTelegramGroupV1',
    method: 'post',
    path: '/api/v1/admin/telegram-groups',
  },
  listTelegramGroups: {
    generated: 'telegramGroupsAdminControllerListTelegramGroupsV1',
    method: 'get',
    path: '/api/v1/admin/telegram-groups',
  },
  getTelegramGroup: {
    generated: 'telegramGroupsAdminControllerGetTelegramGroupV1',
    method: 'get',
    path: '/api/v1/admin/telegram-groups/:id',
  },
  archiveTelegramGroup: {
    generated: 'telegramGroupsAdminControllerArchiveTelegramGroupV1',
    method: 'post',
    path: '/api/v1/admin/telegram-groups/:id/archive',
  },
  bulkArchiveTelegramGroups: {
    generated: 'telegramGroupsAdminControllerBulkArchiveTelegramGroupsV1',
    method: 'post',
    path: '/api/v1/admin/telegram-groups/bulk-archive',
  },
  bulkDeleteTelegramGroups: {
    generated: 'telegramGroupsAdminControllerBulkDeleteTelegramGroupsV1',
    method: 'post',
    path: '/api/v1/admin/telegram-groups/bulk-delete',
  },
  getTelegramGroupJob: {
    generated: 'telegramGroupsAdminControllerGetTelegramGroupJobStatusV1',
    method: 'get',
    path: '/api/v1/admin/telegram-groups/jobs/:jobId',
  },
  updateTelegramGroup: {
    generated: 'telegramGroupsAdminControllerUpdateTelegramGroupV1',
    method: 'put',
    path: '/api/v1/admin/telegram-groups/:id',
  },
  changeTelegramGroupBot: {
    generated: 'telegramGroupsAdminControllerChangeTelegramGroupBotV1',
    method: 'put',
    path: '/api/v1/admin/telegram-groups/:id/bot',
  },
  deleteTelegramGroup: {
    generated: 'telegramGroupsAdminControllerDeleteTelegramGroupV1',
    method: 'delete',
    path: '/api/v1/admin/telegram-groups/:id',
  },
  getTelegramGroupMembers: {
    generated: 'telegramGroupsAdminControllerListTelegramGroupMembersV1',
    method: 'get',
    path: '/api/v1/admin/telegram-groups/:id/members',
  },
  addTelegramGroupMembers: {
    generated: 'telegramGroupsAdminControllerAddTelegramGroupMembersV1',
    method: 'post',
    path: '/api/v1/admin/telegram-groups/:id/members',
  },
  removeTelegramGroupMembers: {
    generated: 'telegramGroupsAdminControllerRemoveTelegramGroupMembersV1',
    method: 'delete',
    path: '/api/v1/admin/telegram-groups/:id/members',
  },
  bulkAddTelegramGroupMembers: {
    generated: 'telegramGroupsAdminControllerBulkAddTelegramGroupMembersV1',
    method: 'post',
    path: '/api/v1/admin/telegram-groups/bulk-add-members',
  },
  bulkRemoveTelegramGroupMembers: {
    generated: 'telegramGroupsAdminControllerBulkRemoveTelegramGroupMembersV1',
    method: 'post',
    path: '/api/v1/admin/telegram-groups/bulk-remove-members',
  },
  createTelegramGroupInviteLink: {
    generated: 'telegramGroupsAdminControllerCreateTelegramGroupInviteLinkV1',
    method: 'post',
    path: '/api/v1/admin/telegram-groups/:id/invite-link',
  },
} as const satisfies Record<string, EndpointDef>;

export type TelegramGroupsEndpointName = keyof typeof TELEGRAM_GROUPS_API_ENDPOINTS;
